// JavaScript source code
import React, { useEffect, useState } from 'react';
import {  useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import dataSubBanner from '../assets/fake-data/data-subbanner';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import { getUser } from '../request';
import LoginDialog from '../components/loginDialog';

function AboutUs(props) {    
    let activeIndex = 1;
    const theData = dataSubBanner.filter(item => {
        return item.id == activeIndex;
    })[0];
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (      
        <div className={`aboutUs ${theData.titleClass}`} >
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>                   

                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail">{theData.pageDetail}</div>
                </div>
                <div className="subcontent aboutus">
                    {
                        screenSize > 991 ? (
                            <div>                            {
                            theData.imgList.map((item, index) => (
                                <img key={index} src={item} />
                            ))
                            }
                            </div>) :
                    (
                            <div>                                   
                                    {
                                        theData.mcontent.map((item, index) => (
                                            <div key={`fuwu${index}`}>
                                                {
                                                    index == 0 ? (
                                                        <div className="fuwu" >
                                                            <div className="title">{item.title}</div>
                                                            <div className="subtitle">{item.msubtitle}</div>
                                                            {
                                                                item.mimgList && item.mimgList.length > 1 && (
                                                                    <Swiper 
                                                                        modules={[Navigation]}
                                                                        spaceBetween={0}
                                                                        slidesPerView={1}
                                                                        loop={true}
                                                                        navigation
                                                                    >
                                                                        {
                                                                            item.mimgList.map((img, index) => (
                                                                                <SwiperSlide key={index}>
                                                                                    <div className="slider-about">
                                                                                        <div className="overlay">
                                                                                            <img src={img} />
                                                                                        </div>
                                                                                    </div>
                                                                                </SwiperSlide>
                                                                            ))
                                                                        }
                                                                    </Swiper>)
                                                            }

                                                        </div>)
                                                        :
                                                        (<div className="fazhan">
                                                            <div className="title">{item.title}</div>
                                                            <div className="subtitle">{item.msubtitle}</div>
                                                            <div className="contentList">
                                                            {
                                                                item.contentList.map((fazhen, index) => (
                                                                    <div className="fazhenItem" key={`fazhenItem${index}`}>
                                                                        <div className="leftIcon">
                                                                            <div className="leftIconCircle">
                                                                            </div>
                                                                            <div className="leftIconShu">
                                                                            </div>
                                                                        </div>
                                                                        <div className="rightContent">
                                                                            <div className="rightContentTitle">
                                                                                <span className="rightContentTitle1">{fazhen.time}</span>
                                                                                <span>{fazhen.title}</span>
                                                                            </div>
                                                                            {
                                                                                fazhen.fazhan.map((fazhandetail,index) => (
                                                                                    <div className="rightContentDetail">
                                                                                        {fazhandetail }
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                ))
                                                                }
                                                            </div>
                                                        </div>)
                                                }
                                            </div>
                                        ))
                                    }                                    
                            </div>
                    )

                }
                <div className="content1">
                {
                    theData.title && <div className="title">{theData.title}</div>
                }
                {
                        theData.subtitle && <div className="subtitle">{theData.subtitle}</div>
                }
                {
                        theData.img && <img  src={theData.img} />
                }
                {
                    theData.content && theData.content.map(c=>( < div className="detail">{c}</div>))
                    }
                    </div>
                </div>
            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>
          
    );
}

export default AboutUs;